import { compose } from 'recompose'
import withType from 'components/common/hoc/withType'
import ValueProposition from './ValueProposition'

export default compose(
  withType({ type: 'ValueProposition', placeholders: ['teasers']})
)(ValueProposition)
